$(document).ready(function ($) {
  "use strict";

  $('.price-slider-bar input').on('input', function () {
    var $wrap = $(this).closest('.price-column');
    var val = $(this).val();
    //console.log(val);

    $wrap.find('.slide-wrap').each(function () {
      if ($(this).data('i') == val) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  });
});